// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h5[data-v-4202b04b] {\n  font-size: 16px;\n}\np[data-v-4202b04b] {\n  font-size: 13px;\n  color: #afafaf;\n  max-width: 80%;\n  min-width: 300px;\n  margin: 0 auto;\n  text-align: center;\n  -webkit-text-decoration: italic;\n          text-decoration: italic;\n}\n.image[data-v-4202b04b] {\n  width: 300px;\n  max-width: 80%;\n}", ""]);
// Exports
module.exports = exports;
